import React from 'react';
import useTagsData from './data';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import CategoryBar from '../CategoryBar';
import SkeletonCategoryBar from '../Skeleton/SkeletonCategoryBar/SkeletonCaegoryBar';

function FilterOptions({
    selectedCategories,
    onFilterClick,
    type,
    config,
    color,
    categoryId,
    showArrowIndicator,
    hideCashbackButton
}) {
    const { tags, isLoading } = useTagsData({
        type: type,
        categoryId: categoryId
    });
    const { path } = useRouteMatch();
    if (path === '/events') {
        return (
            <div className="flex flex-wrap gap-x-2 lg:gap-x-4 gap-y-2 mx-auto items-start  lg:items-center justify-center pt-6 w-[80%] md:w-[70%] ">
                {tags?.map((tag) => (
                    <div key={tag.id} className="flex items-center ">
                        <input
                            type="checkbox"
                            value={tag.id}
                            checked={selectedCategories.includes(tag.id)}
                            onClick={() => onFilterClick(tag.id)}
                            className="z-10  self-center checkbox-sm mx-2  bg-white rounded-md border-gray-100 checked:bg-primary"
                            autoComplete="off"
                        />
                        <p
                            className={` ${
                                config?.darkMode
                                    ? 'text-[#9b9b9b]'
                                    : 'text-black'
                            } uppercase ${config?.events.fontBody} `}
                        >
                            {tag.name}
                        </p>
                    </div>
                ))}
            </div>
        );
    }
    return (
        <>
            <CategoryBar
                categories={tags}
                selectedCategories={selectedCategories}
                onFilterClick={onFilterClick}
                showArrowIndicator={showArrowIndicator}
                scrollable={true}
                showCashbackButton={!hideCashbackButton}
            />
        </>
    );
}

export default FilterOptions;
